import { Component, DestroyRef, OnDestroy, ViewChild, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SmartphotoService } from '../../services/smartphoto.service';
import { CompanyService } from '../../services/company.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SmartphotoFooterComponent } from './smartphoto-footer/smartphoto-footer.component';
import { TransactionService } from '../../services/transaction.service';
import { MiscService } from '../../services/misc.service';
import { AsyncApiService } from '../../services/async-api.service';
import { combineLatest } from 'rxjs';
import { Company, Smartphoto } from '@bdeo-motor/smartphoto-entities';

type TabOptions = 'info' | 'estimation' | 'pictures';

@Component({
  selector: 'app-smartphoto-detail',
  templateUrl: './smartphoto-detail.component.html',
  styleUrls: ['./smartphoto-detail.component.scss']
})
export class SmartphotoDetailComponent implements OnDestroy {
  protected readonly smartphotoService = inject(SmartphotoService);
  private readonly companyService = inject(CompanyService);
  private readonly miscService = inject(MiscService);
  protected readonly transactionService = inject(TransactionService);
  private readonly currentRoute = inject(ActivatedRoute);
  private readonly destroyRef = inject(DestroyRef);
  private readonly asyncApiService = inject(AsyncApiService);

  public smartphoto?: Smartphoto;
  protected company?: Company;
  public company$ = this.companyService.getCurrentCompanyObservable();
  public selected: TabOptions = 'info';
  public smartphoto$ = this.smartphotoService.getCurrentSmartphoto();
  public loading = true;

  @ViewChild(SmartphotoFooterComponent) protected footer!: SmartphotoFooterComponent;

  public async ngOnInit(): Promise<void> {
    this.loading = true;
    await this.getSmartphoto();

    combineLatest([this.smartphoto$, this.company$])
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(([smartphoto, company]) => {
        if (smartphoto && company) {
          this.smartphotoService.abilities.setCompany(company);
          this.smartphotoService.abilities.setSmartphoto(smartphoto);
          this.company = company;
          this.smartphoto = smartphoto;
          this.loading = false;
        }
      });

    (await this.asyncApiService.subscriberWhenAIFinish(this.smartphoto))?.subscribe(async () => {
      await this.getSmartphoto();
    });
  }

  private async getSmartphoto(): Promise<void> {
    this.smartphoto = await this.smartphotoService.get.it(this.currentRoute.snapshot.params['id']);
  }

  public select(selection: TabOptions): void {
    if (!this.transactionService.empty) {
      return;
    }
    this.selected = selection;
    this.miscService.activeGallery(this.selected === 'pictures');
  }

  ngOnDestroy(): void {
    this.transactionService.cancel();
    this.asyncApiService.disconnect();
  }
}
